// extracted by mini-css-extract-plugin
module.exports = {"modalPadding":"20px","backdrop":"Modal_backdrop__3X7yr","modal":"Modal_modal__2SHrF","closeButton":"Modal_closeButton__1vb5x"};